/* Publish by EComposer at 2026-10-24 23:10:28*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tmrcs58avc"]=  window.__ectimmers["ecom-tmrcs58avc"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-tmrcs58avc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tmrcs58avc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7znkm6p4hm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7znkm6p4hm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ikvc0z86zb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ikvc0z86zb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgt4hrh7w3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgt4hrh7w3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibgx9jq61h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibgx9jq61h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q37lj4bnbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q37lj4bnbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nxcmmpxh5w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nxcmmpxh5w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxw933miajl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxw933miajl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnlqbny6uum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnlqbny6uum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0k2antx4xf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0k2antx4xf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqg6gi8plfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqg6gi8plfc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-os839o8yguo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-os839o8yguo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ejq4gll9yfc"]=  window.__ectimmers["ecom-ejq4gll9yfc"] || {};
if(!this.$el)return!1;const t=this.$el,e=this,i=this.settings.animation,s=new CustomEvent("animation",function(){});let o=t.querySelector(".ecom__heading");o.querySelector("a")&&(o=o.querySelector("a")),o.addEventListener("animation",()=>{n()}),o.addEventListener("blur",function(r){r.target.dispatchEvent(s)});function n(){if(i==="typing"){let r=function(){setTimeout(function(){var b;let _=(b=m.settings)==null?void 0:b.animation;if(a.innerText=l[p].slice(0,c),d)if(c>l[p].length){d=!1,_=="typing"&&setTimeout(function(){r()},2e3);return}else c++;else c===0?(d=!0,p=(p+1)%l.length):c--;r()},d?120:60)},a=t.querySelector(".highlight-animation--typing");if(!a)return!1;let l=a.dataset.heading.split("|")||"",c=0,d=!0,p=0;const m=e;r()}if(i==="smooth"){let r=function(){let l=0,c= window.__ectimmers["ecom-ejq4gll9yfc"]["71ayruuu2"] = setInterval(function(){i!="smooth"&&clearInterval(c),l++,a.forEach((d,p)=>{l==a.length&&(l=0),p==l?d.classList.add("is-active"):d.classList.remove("is-active")})},3e3)},a=t.querySelectorAll(".heading-animation--smooth-item");if(!a)return!1;r()}}n()

                    });
                    
                        document.querySelectorAll('.ecom-ejq4gll9yfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejq4gll9yfc', settings: {"animation":"smooth"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qxxp4mwwn1q"]=  window.__ectimmers["ecom-qxxp4mwwn1q"] || {};
if(!this.$el)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");const i=this.id,s=function(o){if(window.EComModal)return o();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&o()});return}let n=0;const r= window.__ectimmers["ecom-qxxp4mwwn1q"]["uahl2brma"] = setInterval(function(){window.EComModal?(clearInterval(r),o()):++n>=300&&clearInterval(r)},50)};e.length&&t&&s(function(){new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+i]})})

                    });
                    
                        document.querySelectorAll('.ecom-qxxp4mwwn1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxxp4mwwn1q', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ib2tlzpy2e"]=  window.__ectimmers["ecom-ib2tlzpy2e"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ib2tlzpy2e"]["8e2g7n7g5"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ib2tlzpy2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ib2tlzpy2e', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x7ckw5g2sv"]=  window.__ectimmers["ecom-x7ckw5g2sv"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-x7ckw5g2sv"]["jumvcse9g"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-x7ckw5g2sv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7ckw5g2sv', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afrro9ej7ze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afrro9ej7ze', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2li57rcen5m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2li57rcen5m', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8o717dcrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8o717dcrl', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqdk5mhbava').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqdk5mhbava', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhcyhkprxsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhcyhkprxsh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r29tyslz2ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r29tyslz2ma', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-56qmjuf5pgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-56qmjuf5pgi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f16iy9pnjvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f16iy9pnjvi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcapir7sfnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcapir7sfnb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw6q4q1468').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw6q4q1468', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eeijf0ba06i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eeijf0ba06i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drnf5a584w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drnf5a584w', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}